var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreepeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8594,
    cy: 20.5,
    r: 20,
    fill: "#007AFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3230_12778)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.8594,
    cy: 15.5,
    r: 3,
    stroke: "#F8F8F8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8594,
    cy: 18.5,
    r: 2,
    stroke: "#F8F8F8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.8594,
    cy: 18.5,
    r: 2,
    stroke: "#F8F8F8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8594 26.5C15.8594 23.7386 18.098 21.5 20.8594 21.5V21.5C23.6208 21.5 25.8594 23.7386 25.8594 26.5V28.5H15.8594V26.5Z",
    stroke: "#F8F8F8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1329 24.8648L17.0779 25.1917L17.2544 24.6817L16.9248 24.2543L16.1329 24.8648ZM15.8594 28.5V29.5H16.8594V28.5H15.8594ZM9.85938 28.5H8.85938V29.5H9.85938V28.5ZM16.8594 26.5C16.8594 26.0401 16.9366 25.6004 17.0779 25.1917L15.1878 24.5379C14.9747 25.154 14.8594 25.8146 14.8594 26.5H16.8594ZM16.8594 28.5V26.5H14.8594V28.5H16.8594ZM15.8594 27.5H15.3594V29.5H15.8594V27.5ZM15.3594 27.5H9.85938V29.5H15.3594V27.5ZM10.8594 28.5V27H8.85938V28.5H10.8594ZM10.8594 27C10.8594 25.6193 11.9787 24.5 13.3594 24.5V22.5C10.8741 22.5 8.85938 24.5147 8.85938 27H10.8594ZM13.3594 24.5C14.1654 24.5 14.8821 24.8803 15.3409 25.4754L16.9248 24.2543C16.1037 23.1892 14.8118 22.5 13.3594 22.5V24.5Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5859 24.8648L24.6408 25.1917L24.4644 24.6817L24.7939 24.2543L25.5859 24.8648ZM25.8594 28.5V29.5H24.8594V28.5H25.8594ZM31.8594 28.5H32.8594V29.5H31.8594V28.5ZM24.8594 26.5C24.8594 26.0401 24.7822 25.6004 24.6408 25.1917L26.5309 24.5379C26.7441 25.154 26.8594 25.8146 26.8594 26.5H24.8594ZM24.8594 28.5V26.5H26.8594V28.5H24.8594ZM25.8594 27.5H26.3594V29.5H25.8594V27.5ZM26.3594 27.5H31.8594V29.5H26.3594V27.5ZM30.8594 28.5V27H32.8594V28.5H30.8594ZM30.8594 27C30.8594 25.6193 29.7401 24.5 28.3594 24.5V22.5C30.8447 22.5 32.8594 24.5147 32.8594 27H30.8594ZM28.3594 24.5C27.5534 24.5 26.8366 24.8803 26.3778 25.4754L24.7939 24.2543C25.6151 23.1892 26.907 22.5 28.3594 22.5V24.5Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3230_12778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.85938 8.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreepeople);
export default __webpack_public_path__ + "static/media/threepeople.6afd4df9f57045a8d1ffc88d36d69a51.svg";
export { ForwardRef as ReactComponent };